<template>
  <div>
    <b-card-code class="mt-2 principal">
      <b-button
        id="btn-excel"
        ref="btnexcel"
        variant="primary"
        size="sm"
        style="
          margin-right: 1%;
          background: #37ef00 !important;
          border-color: #37ef00 !important;
        "
        @click="cargarPersonas((excel_btn = '1'))"
      >
        <font-awesome-icon icon="fa-solid fa-file-excel" />
      </b-button>
      <b-button
        id="btn-pdf"
        variant="danger"
        size="sm"
        @click="cargarPersonas((excel_btn = ''), (pdf_btn = '1'))"
      >
        <font-awesome-icon icon="fa-solid fa-file-pdf" />
      </b-button>

      <b-row class="mt-2">
        <b-col md="4">
          <b-form-group>
            <label>Razón social:</label>
            <b-form-input
              v-model="razon_social"
              placeholder="Buscar por razón social"
              type="text"
              class="d-inline-block"
            />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group>
            <label>Identificación:</label>
            <b-form-input
              v-model="identificacion"
              placeholder="Buscar por identificación"
              type="text"
              class="d-inline-block"
            />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group>
            <label>Tipo:</label>
            <v-select
              id="estado"
              v-model="selectedTipoPersona"
              :options="tipoPersona"
              :reduce="(option) => option.value"
              label="text"
            />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group>
            <label>Correo electrónico:</label>
            <b-form-input
              v-model="email"
              placeholder="Buscar por correo electrónico"
              type="text"
              class="d-inline-block"
            />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group>
            <label>Tipo persona pasajero:</label>
            <v-select
              id="estado"
              v-model="selectedTipoPersonaPasajero"
              :options="tipoPersonaPasajero"
              :reduce="(option) => option.value"
              label="text"
            />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group>
            <label>Tipo residente:</label>
            <v-select
              id="estado"
              v-model="selectedTipoResidente"
              :options="tipoResidente"
              :reduce="(option) => option.value"
              label="text"
            />
          </b-form-group>
        </b-col>
        <b-col md="4">
          <b-form-group>
            <label>Serie residente:</label>
            <b-form-input
              v-model="serie"
              placeholder="Buscar por serie del residente"
              type="text"
              class="d-inline-block"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="4" class="pb-2">
          <b-button variant="primary" size="sm" @click="filtrar">
            <font-awesome-icon icon="fa-solid fa-magnifying-glass" /> Consultar
          </b-button>
        </b-col>
      </b-row>
    </b-card-code>

    <b-overlay :show="mostrarLoader" opacity="0.50" rounded="sm">
      <b-card-code class="principal">
        <b-col cols="12" class="pr-0 pl-0 mt-2">
          <b-table
            v-if="items.length > 0"
            bordered
            striped
            responsive
            :per-page="perPage"
            :current-page="currentPage"
            :items="items"
            :fields="fields"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            :filter="filter"
            :filter-included-fields="filterOn"
            @filtered="onFiltered"
          >
            <template #cell(razonSocial)="data">
              <b-link
                v-if="data.item.razonSocial"
                :to="{
                  name: 'editpersona',
                  params: { token: data.item.token },
                }"
              >
                {{ data.item.razonSocial }}
              </b-link>
            </template>
            <template #cell(tipoPasajero)="data">
              {{ procesarTipoPersonaPasajero(data.item.tipoPersonaPasajero) }}
              <br />
              {{ procesarTipoResidente(data.item.tipoResidente) }}
            </template>
            <template #cell(tipoNatJur)="data">
              {{ procesarTipoPersona(data.value) }}
            </template>
            <template #cell(identificacion)="data">
              <span v-if="data.item.cedula">{{ data.item.cedula }}</span>
              <span v-else>{{ data.item.ruc }}</span>
              <b-badge v-if="data.item.esExtranjero === true" variant="primary">
                Extranjero
              </b-badge>
            </template>
            <template #cell(residencia)="data">
              <p v-if="data.item.residente">
                <span v-if="data.item.residente.residente_serie"
                  >{{ data.item.residente.residente_serie }}
                </span>
                <span v-if="data.item.residente.residente_fecha_caducidad"
                  ><br />{{
                    new Date(
                      data.item.residente.residente_fecha_caducidad +
                        "T00:00:00"
                    ).toLocaleDateString("es-EC")
                  }}</span
                >
              </p>
              <a v-else>N/A</a>
            </template>
            <template #cell(activo)="data">
              <b-badge :variant="is_active[1][data.value]">
                {{ is_active[0][data.value] }}
              </b-badge>
            </template>
          </b-table>

          <div v-else class="text-center">
            <p>No se encontraron registros</p>
          </div>
        </b-col>

        <b-col cols="12" class="mb-2">
          <b-pagination
            v-if="items.length > 0"
            v-model="currentPageModificado"
            :total-rows="totalRows"
            :per-page="perPage"
            first-number
            last-number
            :small="true"
            class="mb-0"
            align="center"
            prev-class="prev-item"
            next-class="next-item"
            @change="prueba"
          >
            <template #prev-text>
              <feather-icon icon="ChevronLeftIcon" size="18" />
            </template>
            <template #next-text>
              <feather-icon icon="ChevronRightIcon" size="18" />
            </template>
          </b-pagination>
        </b-col>
      </b-card-code>
    </b-overlay>
  </div>
</template>

<script>
import {
  BTable,
  BAvatar,
  BBadge,
  BRow,
  BCol,
  BFormGroup,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BImg,
  BIcon,
  BCardHeader,
  BCardGroup,
  BCardTitle,
  BLink,
  BOverlay,
} from "bootstrap-vue";
import BCardCode from "@core/components/b-card-code";

import axios from "@/libs/axios";
import actions from "@/assets/utils/utils";
import vSelect from "vue-select";
import $ from "jquery";
import Vue from "vue";

export default {
  components: {
    BCardHeader,
    BCardGroup,
    BCardTitle,
    BCardCode,
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BImg,
    BIcon,
    BLink,
    vSelect,
    BOverlay,
  },
  data() {
    return {
      perPage: 15,
      pageOptions: [3, 5, 10],
      totalRows: 1,
      currentPage: 1,
      currentPageModificado: 1,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      infoModal: {
        id: "info-modal",
        title: "",
        content: "",
      },
      fields: [
        {
          key: "razonSocial",
          label: "Razón social",
          sortable: true,
          thClass: "text-center",
          thStyle: { width: "30%" },
        },
        {
          key: "tipoPasajero",
          label: "Tipo pasajero",
          sortable: true,
          thClass: "text-center",
          thStyle: { width: "15%" },
        },
        {
          key: "identificacion",
          label: "Identificación",
          sortable: true,
          thClass: "text-center",
          thStyle: { width: "15%" },
        },
        {
          key: "residencia",
          label: "Residencia",
          sortable: true,
          thClass: "text-center",
          thStyle: { width: "10%" },
        },
        {
          key: "tipoNatJur",
          label: "Tipo",
          sortable: true,
          thClass: "text-center",
          thStyle: { width: "10%" },
        },
        {
          key: "email",
          label: "Correo electrónico",
          sortable: true,
          thClass: "text-center",
          thStyle: { width: "10%" },
        },
        {
          key: "activo",
          label: "Activo",
          sortable: true,
          thClass: "text-center",
          thStyle: { width: "10%" },
        },
      ],
      items: [],
      is_active: [
        {
          false: "Inactivo",
          true: "Activo",
        },
        {
          false: "light-secondary",
          true: "light-success",
        },
      ],
      status: [
        {
          1: "Current",
          2: "Professional",
          3: "Rejected",
          4: "Resigned",
          5: "Applied",
        },
        {
          1: "light-primary",
          2: "light-success",
          3: "light-danger",
          4: "light-warning",
          5: "light-info",
        },
      ],

      razon_social: "",
      identificacion: "",
      email: "",
      serie: "",

      selectedTipoPersona: "all",
      selectedTipoPasajero: "all",
      selectedTipoPersonaPasajero: "all",
      selectedTipoResidente: "all",

      tipoPersona: [],
      tipoPasajero: [],
      tipoPersonaPasajero: [],
      tipoResidente: [],

      // total_personas: 0,
      mostrarLoader: true,
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => ({ text: f.label, value: f.key }));
    },
  },
  created() {
    this.comprobarPermisos();
    $("#btn-excel").remove();
    $("#btn-pdf").remove();
    $("#btn-print").remove();
    $("#eliminar-viajes").remove();
    $("#btn-abrir-caja").remove();
    this.setToken();
  },
  mounted() {
    actions.setearTitulo("");
    // this.cargarTipoPasajero()
    // this.cargarTipoPersona()
    // Set the initial number of items
    this.cargarPersonas();
    // this.totalRows = this.items.length
    $("#contenedor-botones").append($("#btn-excel")).append($("#btn-pdf"));
  },
  methods: {
    comprobarPermisos() {
      if (
        localStorage.getItem("permisos").indexOf("per_per_consultar") === -1
      ) {
        this.$router.push({ name: "not-permitted" });
      }
    },
    filtrar() {
      this.cargarPersonas();
    },
    procesarTipoPasajero(texto) {
      for (const pasajero of this.tipoPasajero) {
        if (texto === pasajero.value) {
          return pasajero.text;
        }
      }
    },
    procesarTipoPersona(texto) {
      for (const persona of this.tipoPersona) {
        if (texto === persona.value) {
          return persona.text;
        }
      }
    },
    procesarTipoPersonaPasajero(texto) {
      for (const persona_pasajero of this.tipoPersonaPasajero) {
        if (texto === persona_pasajero.value) {
          return persona_pasajero.text;
        }
      }
    },
    procesarTipoResidente(texto) {
      for (const residente of this.tipoResidente) {
        if (texto === residente.value) {
          return residente.text;
        }
      }
    },
    prueba(value) {
      const pagina_actual = value;
      // this.currentPage = pagina_actual
      const limite_superior = value * this.perPage;
      const limite_inferior = (value - 1) * this.perPage;
      const desde = limite_inferior;
      const hasta = limite_superior;

      this.cargarPersonas("", "", desde, hasta, pagina_actual);
    },
    cargarPersonas(
      excel_btn = "",
      pdf_btn = "",
      desde = 0,
      hasta = 15,
      pagina_actual = 1
    ) {
      this.mostrarLoader = true;
      if (this.selectedTipoPersonaPasajero === null) {
        this.selectedTipoPersonaPasajero = "all";
      }
      if (this.selectedTipoResidente === null) {
        this.selectedTipoResidente = "all";
      }
      if (this.selectedTipoPersona === null) {
        this.selectedTipoPersona = "all";
      }
      axios
        .post("api", {
          query: `query getAllPersonas($serie: String!, $identificacion: String!, $razonSocial: String!, $tipo: String!, $email: String!, $desde: Int!, $hasta: Int!, $tipoPersonaPasajero: String!, $tipoResidente: String!, $excel: String!, $pdf: String!){
                    getAllPersonas(serie:$serie, identificacion:$identificacion, razonSocial:$razonSocial,tipo:$tipo, email:$email, desde: $desde, hasta: $hasta, tipoPersonaPasajero:$tipoPersonaPasajero, tipoResidente:$tipoResidente, excel:$excel, pdf:$pdf){
                        total,
                        personas{
                            token,
                            activo,
                            cedula,
                            ruc,
                            tipoNatJur,
                            tipoPasajero,
                            esExtranjero,
                            razonSocial,
                            email,
                            tipoResidente,
                            tipoPersonaPasajero,
                            residente{
                                residente_serie: residenteSerie,
                                residente_fecha_caducidad: residenteFechaCaducidad,
                            }
                        },
                        listaTipoPasajero{
                            value,
                            text
                        },
                        listaTipoPersona{
                            value,
                            text
                        },
                        listaTipoPersonaPasajero{
                          value,
                          text
                        },
                        listaTipoResidente{
                          value,
                          text
                        },
                        total,
                        dataarchivo,
                        status,
                        message
                    }
                }`,
          variables: {
            serie: this.serie,
            identificacion: this.identificacion,
            tipo: this.selectedTipoPersona,
            email: this.email,
            tipoPersonaPasajero: this.selectedTipoPersonaPasajero,
            tipoResidente: this.selectedTipoResidente,
            razonSocial: this.razon_social,
            excel: excel_btn,
            pdf: pdf_btn,
            desde: desde,
            hasta: hasta,
          },
        })
        .then((response) => {
          if (response.status === 200) {
            if (response.data.data.getAllPersonas.status === "success") {
              if (this.tipoPersona.length === 0) {
                this.tipoPersona =
                  response.data.data.getAllPersonas.listaTipoPersona;
              }
              if (this.tipoPasajero.length === 0) {
                this.tipoPasajero =
                  response.data.data.getAllPersonas.listaTipoPasajero;
              }
              if (this.tipoPersonaPasajero.length === 0) {
                this.tipoPersonaPasajero =
                  response.data.data.getAllPersonas.listaTipoPersonaPasajero;
              }
              if (this.tipoResidente.length === 0) {
                this.tipoResidente =
                  response.data.data.getAllPersonas.listaTipoResidente;
              }

              if (response.data.data.getAllPersonas.personas) {
                this.items = response.data.data.getAllPersonas.personas;
                // this.items = []
                this.totalRows = response.data.data.getAllPersonas.total;
                // if(desde === 0){
                //     this.currentPage = 1
                // }
                // else{
                this.currentPage = 1;
                this.currentPageModificado = pagina_actual;
                // }
              } else {
                const data = response.data.data.getAllPersonas.dataarchivo;
                if (excel_btn === "1") {
                  actions.cargarArchivos(
                    data,
                    "Personas.xlsx",
                    "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64"
                  );
                } else {
                  actions.cargarArchivos(
                    data,
                    "Personas.pdf",
                    "data:application/pdf;base64"
                  );
                }
              }
            }
          }
          this.mostrarLoader = false;
        });
    },
    setToken() {
      const usuarioCookie = this.$cookie.get("usuario");
      if (usuarioCookie != null) {
        const user = JSON.parse(usuarioCookie);
        axios.defaults.headers.common.Authorization = `JWT ${user.token}`; // for all requests
      }
    },
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`;
      this.infoModal.content = JSON.stringify(item, null, 2);
      this.$root.$emit("bv::show::modal", this.infoModal.id, button);
    },
    resetInfoModal() {
      this.infoModal.title = "";
      this.infoModal.content = "";
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    newPersona() {
      this.$router.push({ name: "formpersona" });
    },
  },
};
</script>
<style>
.principal .card-header {
  display: none !important;
}
.principal .card-body {
  padding-bottom: 0 !important;
}
[dir] .table th,
[dir] .table td {
  padding-left: 1%;
  padding-right: 1%;
}
</style>
